import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Alert = createReactClass({
  propTypes: {
    message: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  },

  getInitialState() {
    return {
      showShow: true,
    };
  },

  handleClosed() {
    this.setState({showShow: false});
  },

  render() {
    const {message, type} = this.props;
    const alertClassName = classnames('alert', 'bg-body', `alert-${type}`);

    if (this.state.showShow) {
      return (
        <div className={alertClassName}>
          <button onClick={this.handleClosed} type="button" className="close" aria-hidden="true"><i className="ficon ficon-times"></i></button>
          <div>{message}</div>
        </div>
      );
    }

    return null;
  },
});

export default Alert;



// WEBPACK FOOTER //
// ./app/javascript/components/Alert.js